import { Injectable } from "@angular/core";
import { RedirectToLoginService } from "@modules/common/services/redirect-to-login.service";
import { UserSessionService } from "@modules/common/services/user-session.service";

@Injectable({
    providedIn: 'root'
})
export class LogoutService {
    constructor(
        private _userSessionService: UserSessionService,
        private _redirectToLoginService: RedirectToLoginService
    ) { }

    public logout(clearRedirectedFromUrl: boolean = true): void {
        this._userSessionService.signOut().subscribe(() => {
            this._redirectToLoginService.redirectToLogin();
            if (clearRedirectedFromUrl) {
                this._redirectToLoginService.clearRedirectedFromUrl();
            }
        });
    }
}
